module.exports = __webpack_public_path__ + "img/Widget.d59cab7f.png";